import React, { useState } from "react";
import { Box, Button, Container, Typography, TextField, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NicknameRegister: React.FC = () => {
    const [nickname, setNickname] = useState<string>("");
    const navigate = useNavigate();

    const handleNicknameSubmit = () => {
        if (nickname.trim()) {
            // 例: fetch('/api/ranking', { method: 'POST', body: JSON.stringify({ nickname }) });
            console.log("登録されたニックネーム:", nickname);

            setNickname("");
            alert("ニックネームが登録されました！");
            navigate("/staff-dashboard");
        } else {
            alert("ニックネームを入力してください。");
        }
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 4 }}>
            <Typography variant="h4" align="center" gutterBottom>
                ニックネーム登録
            </Typography>
            <Paper sx={{ mt: 4, p: 3 }}>
                <Typography variant="h6" gutterBottom>
                    ランキング用のニックネームを入力してください
                </Typography>
                <TextField
                    label="ニックネーム"
                    value={nickname}
                    onChange={(e) => setNickname(e.target.value)}
                    fullWidth
                    sx={{ mb: 2 }}
                />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNicknameSubmit}
                    fullWidth
                >
                    登録
                </Button>
            </Paper>
            <Box display="flex" justifyContent="center" mt={4}>
                <Button variant="outlined" onClick={() => navigate("/staff-dashboard")}>
                    戻る
                </Button>
            </Box>
        </Container>
    );
};

export default NicknameRegister;